import { render } from "./loader.vue?vue&type=template&id=2179b9b8"
const script = {}

import exportComponent from "/Users/thijsfenne/Ontwikkeling/vastejob.nl/wp-content/themes/designated-child/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__